<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="title">是否放弃该任务</div>
      <div class="sub-title">放弃任务后需重新领取</div>
      <div class="btn-middle" @click='giveUp'>放弃</div>
      <div class="btn-middle" @click='hide'>不放弃</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 241px;
    padding: 30px 0;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .sub-title {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto 10px;
    }
  }
</style>
<script>
  import Dialog from 'components/Dialog'
  import { mapActions } from 'vuex'
  import { URI_APPTASK_GIVEUP } from '@/store/modules/dashboard/type'
  export default {
    props: {
      taskIdGive: ''
    },

    components: {
      Dialog
    },
    mounted () {
      $bus.$on('confirm', () => {
        this.show()
      })
    },
    destroyed () {
      $bus.$off('confirm')
    },
    methods: {
      ...mapActions({
        giveUpTask: URI_APPTASK_GIVEUP
      }),
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      },
      giveUp () {
        this.$refs.p.hide()
        this.giveUpTask({ tid: this.taskIdGive })
        $storage.remove('HAS_OPEN_APP_STORE')
        $storage.remove('HAS_OPEN_APP')
        $router.push('/dashboard')
      }
    }
  }
</script>
